// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tickets_CriacategoriaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Tickets_CriacategoriaResponseDados {
ID: number
NomeCategoria: string
created_at?: string
updated_at?: string
}

export type Tickets_CriacategoriaResponse = ApiResponse<Tickets_CriacategoriaResponseDados>;

registerResponseContract('Tickets_CriacategoriaResponse', {
  ID:            { type: 'number',  required: true },
  NomeCategoria: { type: 'string',  required: true },
  created_at:    { type: 'string',  required: false },
  updated_at:    { type: 'string',  required: false },
})
